var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "delete" } }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("message.delete.title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("message.delete.sub_title")))]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.result,
            expression: "result"
          }
        ]
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.success,
                expression: "!success"
              }
            ]
          },
          [
            _c("p", { staticClass: "has-text-danger" }, [
              _vm._v(_vm._s(_vm.errMsg))
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.success,
                expression: "success"
              }
            ]
          },
          [
            _c("p", { staticClass: "has-text-success" }, [
              _vm._v(_vm._s(_vm.$t("message.delete.success")))
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "lds-roller"
      },
      [
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loading && _vm.main,
            expression: "!loading && main"
          }
        ]
      },
      [
        _c(
          "section",
          [
            _c("p", [_vm._v(_vm._s(_vm.$t("message.delete.1")))]),
            _vm._v(" "),
            _c("b-input", {
              attrs: { type: "email", maxlength: "50" },
              model: {
                value: _vm.fileName,
                callback: function($$v) {
                  _vm.fileName = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "fileName"
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: { click: _vm.deleteFile }
              },
              [_vm._v(_vm._s(_vm.$t("message.delete.exec")))]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-552c5e5b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-552c5e5b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Delete.vue
// module id = null
// module chunks = 